export function DealerTermsAndConditionsCtrl ($scope, $uibModalInstance, settings, dealer) {
  $scope.loaded = true;

  $scope.settings = settings;
  $scope.dealer   = dealer;

  $scope.grantAccess = function (type) {
    $uibModalInstance.close(true);
  };

  $scope.close = function () {
    $uibModalInstance.dismiss();
  };
}